{
  "decrease": "{fieldLabel} azalt",
  "increase": "{fieldLabel} arttır",
  "numberField": "Sayı alanı"
}
